/*
 * @Author: lbh
 * @Date: 2025-08-26 15:49:02
 * @LastEditors: lbh
 * @LastEditTime: 2025-08-26 16:05:26
 * @Description: 自助點餐機 工具類
 */
const kioskUtil = {
  app: {
    // ? 返回主頁 傳1返回首頁, 傳0是網頁返回上一頁
    back(e) {
      // *  返回上一頁, 如果網頁能返回上一頁會優先觸發網頁返回
      let url = `ricepos://action?action_name=back`;
      if(e == 1){
        // * 返回首頁
        url = `ricepos://action?action_name=backToHome`;
      }
      console.log("觸發 kiosk 返回主頁", url);
      sessionStorage.setItem("menu-index-scroll-top", 0);
      location.href = url;
    },

    // ? 跳轉到訂單頁
    toOrder(orderId) {
      let url = `ricepos://activity_page?jump_name=kiosks_checkout&orderId=${orderId}`;
      console.log("觸發 kiosk 跳轉到訂單頁", url);
      location.href = url;
    },
  },
  kiosk: {
    key: "Kiosk_Mode",
    set() {
      localStorage.setItem(this.key, "1");
    },
    get() {
      return localStorage.getItem(this.key) == "1";
    },
    clear() {
      localStorage.removeItem(this.key);
    },
  },
  loading: {
    show(title) {
      // * 定義 loading 框
      if (document.querySelector("#kiosk-loading"))
        document.querySelector("#kiosk-loading").remove();
      if (document.querySelector(".kiosk-loading-style"))
        document.querySelector(".kiosk-loading-style").remove();
      let loadingBox = document.createElement("div");
      loadingBox.id = "kiosk-loading";

      // * loading 的 mask
      let mask = document.createElement("div");
      mask.classList.add("kiosk-loading-mask");
      // * 阻止默认事件
      mask.onclick = (e) => {
        e.preventDefault();
      };

      // * loading 的 img
      let svg = document.createElement("img");
      svg.src = require("@/assets/ricepos/loading.svg");

      mask.appendChild(svg);

      // * 提示的文字
      let text = document.createElement("div");
      text.innerText = title || "正在加載中...";
      text.classList.add("kiosk-loading-text");
      mask.appendChild(text);

      loadingBox.appendChild(mask);

      let style = document.createElement("style");
      style.classList.add("kiosk-loading-style");
      style.innerText = `
        @keyframes kiosk-loading {
          0% {transform: rotate(0deg);}
          100% {transform: rotate(360deg);}
        }

        #kiosk-loading{
          position: fixed;
          left:0;
          top:0;
          height:100vh;
          width:100vw;
          z-index:9999;
          display:flex;
          justify-content:center;
          align-items:center;
        }
        
        #kiosk-loading .kiosk-loading-mask{
          width: 7.8125rem;
          padding:0.625rem;
          border-radius:0.5rem;
          background-color: rgba(0,0,0,.5);
          display:flex;
          flex-direction:column;
          justify-content:center;
          align-items:center;
        }

        #kiosk-loading img{
          width:3.125rem;
          animation: kiosk-loading 1.5s linear infinite;
        }

        #kiosk-loading .kiosk-loading-text{
          margin-top:0.625rem;
          color:#FFF;
          font-size:0.875rem;
        }
      `;

      document.body.appendChild(style);
      document.body.appendChild(loadingBox);
    },
    hide() {
      if (document.querySelector("#kiosk-loading"))
        document.querySelector("#kiosk-loading").remove();
      if (document.querySelector(".kiosk-loading-style"))
        document.querySelector(".kiosk-loading-style").remove();
    },
  },
  util: {},
};
export default kioskUtil;
